import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  MenuItem,
  Menu,
  Box,
} from "@mui/material/";
import {
  Facebook,
  Twitter,
  Instagram,
  YouTube,
  Padding,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useIndexPageData } from "../contextapi/Indexpagedata";
import apiClient from "../api/apiClient";
import CookiePreferences from "./CookiePreferences";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  socialIcons: {
    marginLeft: theme.spacing(2),
  },
}));

const Footer = () => {
  const {
    profiledata,
    fetchDataprofile,
    cartItems,
    fetchcart,
    setprofiledata,
  } = useIndexPageData();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [listing, setlisting] = React.useState({});
  const [showCookieSettings, setShowCookieSettings] = React.useState(false);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const fetch = async () => {
    const result = await apiClient.get(
      "/listings/listings-count/?called_from=home"
    );
    setlisting(result.data);
  };
  useEffect(() => {
    fetch();
  }, []);
  return (
    <>
      <Box
        sx={{
          bgcolor: "#2E2E2E",
          position: "absolute",
          left: "0px",
          right: "0px",
          bottom: "0px",
          zIndex: 10,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "start", lg: "center" },
            padding: { xs: "10px 20px", lg: "5px 20px" },
            marginRight: { xs: "0px", lg: "60px" },
            flexWrap: { xs: "wrap", lg: "nowrap", gap: 2 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
              marginLeft: {
                xs: "16px",
                lg: "0px",
              },
            }}
          >
            <a
              href="https://www.facebook.com/profile.php?id=61591298257411"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <IconButton sx={{ bgcolor: "black", borderRadius: "50%" }}>
                <Facebook sx={{ color: "#fff" }} />
              </IconButton>
            </a>
            <a
              href="https://www.youtube.com/@MockeeTeam"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <IconButton sx={{ bgcolor: "black", borderRadius: "50%" }}>
                <YouTube sx={{ color: "#fff" }} />
              </IconButton>
            </a>
            <a
              href="https://www.instagram.com/mockee.io"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <IconButton sx={{ bgcolor: "black", borderRadius: "50%" }}>
                <Instagram sx={{ color: "#fff" }} />
              </IconButton>
            </a>
          </Box>

          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gridTemplateColumns: { xs: "repeat(2, 1fr)", md: "none" },
              flexDirection: { md: "row" },
              width: { xs: "100%", sm: "auto" },
              justifyContent: { md: "center" },
              alignItems: "center",
            }}
          >
            <MenuItem sx={{ py: "6px", px: "16px" }}>
              <Typography variant="body2" color="white">
                <Link
                  to="/terms-and-conditions"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  Terms And Conditions
                </Link>
              </Typography>
            </MenuItem>

            <MenuItem
              onClick={() => setShowCookieSettings(true)}
              sx={{ py: "6px", px: "16px" }}
            >
              <Typography
                variant="body2"
                color="white"
                sx={{ cursor: "pointer" }}
              >
                Manage Cookies
              </Typography>
            </MenuItem>

            <MenuItem sx={{ py: "6px", px: "16px" }}>
              <Typography variant="body2" color="white">
                <Link
                  to="/privacy-policy"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  Privacy Policy
                </Link>
              </Typography>
            </MenuItem>

            <MenuItem sx={{ py: "6px", px: "16px" }}>
              <Typography variant="body2" color="white">
                <Link
                  to="/about-us"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  About Us
                </Link>
              </Typography>
            </MenuItem>

            <MenuItem sx={{ py: "6px", px: "16px" }}>
              <Typography variant="body2" color="white">
                <Link
                  to="/become-a-seller"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  Become A Seller
                </Link>
              </Typography>
            </MenuItem>

            <MenuItem sx={{ py: "6px", px: "16px" }}>
              <Typography variant="body2" color="white">
                <Link
                  to="/newsletter-terms"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  Newsletter Terms
                </Link>
              </Typography>
            </MenuItem>

            <MenuItem sx={{ py: "6px", px: "16px" }}>
              <Typography variant="body2" color="white">
                <a
                  href="mailto:contact@mockee.io"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  Contact
                </a>
              </Typography>
            </MenuItem>
          </Box>

          <Typography
            sx={{
              display: { xs: "none", md: "flex" },
              width: {
                xs: "100%",
                sm: "auto",
              },
              paddingLeft: {
                xs: "16px",
                lg: "0px",
              },
            }}
            color="white"
            variant="p"
          >
            {listing?.count} Mockups Online
          </Typography>
        </Toolbar>
      </Box>

      <CookiePreferences
        show={showCookieSettings}
        onClose={() => setShowCookieSettings(false)}
      />
    </>
  );
};

export default Footer;
